
















import { useVModel } from '@vueuse/core';
import {
  computed,
  defineComponent,
  PropType,
  ref,
  watch
} from '@vue/composition-api';

import { ISystemError } from '@/models/error/error.types';
import { SystemError } from '@/models';

export default defineComponent({
  name: 'WorkflowFormSubmissionCalculatedField',

  props: {
    value: [String, Number] as PropType<string | number>,

    errorMessages: {
      type: [String, Array] as PropType<string | string[]>
    }
  },

  setup(props) {
    const vModel = useVModel(props);
    const error = ref<ISystemError | null>(null);

    watch(
      vModel,
      value => {
        if (value === null) {
          error.value = new SystemError({
            name: 'System Error',
            message: 'Evaluation configuration is misconfigured'
          });
        } else {
          error.value = null;
        }
      },
      {
        immediate: true
      }
    );

    const errorMessageList = computed(() => {
      let errorList: string[] = [];

      if (error.value) {
        errorList.push(error.value.message);
      }
      if (props.errorMessages) {
        if (Array.isArray(props.errorMessages)) {
          errorList.push(...props.errorMessages);
        } else {
          errorList.push(props.errorMessages);
        }
      }

      return errorList;
    });

    return {
      vModel,
      errorMessageList
    };
  }
});
